export default "__VITE_ASSET__dfd261c9__"